import {dynamicFilterOperators} from "../dynamicFilterOperators";
import { vnTemplate } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { filterSingle_multiLevel_selector_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template';
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import {amCharts_v4_date_basic_template} from "./amCharts_v4_date_basic_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { vnApp_sentinelbi } from '../vnApp_sentinelbi';

declare var ko: any;


export class interactionOverview_template extends vnTemplate {

    protected eventsChart: amCharts_v4_date_basic_template;
    protected brandFilter: filterSingle_multiLevel_selector_template;
    protected dateRangeFilter: filterDate_template;
    protected presetFilter: presetFilter_template;
    protected exportDataCsv: exportDataCsv;
    protected resultsInfo: resultsInfo_template;
    protected pagination: pagination_template;
    protected annotationTooltip: infoButton_template;

    /**
     * @inheritDoc
     */
    protected getTemplateHtml(): string{

        return `


            <div id="report-results">

                <div class="page-header">
                    <h2 class="title-page">Events Overview</h2>

                    <div data-bind="if: reportStatusData()" class="report-status">
                        <div class="button-default"
                            data-bind="css: {
                                'status-ok': reportStatusData().status === 'LIVE',
                                'status-delayed': reportStatusData().status === 'DELAYED',
                                'status-error': reportStatusData().status === 'ERRORS'
                            }">
                            <span data-bind="css: {
                                'icon i-live': reportStatusData().status === 'LIVE'
                            }"></span>

                            <div class="status" data-bind="text: reportStatusData().status"></div>

                            <div data-bind="if: reportStatusData().status === 'DELAYED' || reportStatusData().status === 'ERRORS'">
                                <div class="report-status-tooltip">
                                    <p style="text-transform: none;" data-bind="html: reportStatusData().message"></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <div class="w-justify block-filters filters-responsive">
                    <div class="w-left flex-none sidebar-filters-js-only">
                        <button data-bind="event: { click: onSidebarToggle }" class="button-default no-text icon i-preferences preferences no-after" type="button" title="report preferences">
                            <span class="hide-text">REPORT PREFERENCES</span>
                        </button>

                        <nav class="sidebar-default" data-bind="css: {'is-open': sidebarToggle()}">
                            <div class="sidebar-default-header">
                                <span class="label-default sidebar-default-header icon i-preferences">Report Preferences</span>
                                <button data-bind="event: { click: onSidebarToggle }" type="button" class="btn-close-default icon i-close"><span></span></button>
                            </div>

                            <div class="sidebar-default-body">
                                <div>
                                    <span class="label-default icon i-intervals">Interval</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Hourly">
                                                <span>Hourly</span>
                                                <input type="radio" id="radio-hourly" name="switch-time-group" value="hourly" data-bind="event: {change: onTimeGroupSwitch.bind($data, 'hourly')}, checked: timeGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Daily">
                                                <span>Daily</span>
                                                <input type="radio" id="radio-daily" name="switch-time-group" value="daily" data-bind="event: {change: onTimeGroupSwitch.bind($data, 'daily')}, checked: timeGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span class="label-default icon i-dimensions">Dimensions</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Default">
                                                <span>Default</span>
                                                <input type="radio" id="radio-dimension-time" name="switch-dimension-group" value="time" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'time')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Device">
                                                <span>Device</span>
                                                <input type="radio" id="radio-dimension-device" name="switch-dimension-device" value="device" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'device')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Traffic Classification">
                                                <span>Traffic Classification</span>
                                                <input type="radio" id="radio-dimension-trafficClassification" name="switch-dimension-trafficClassification" value="trafficClassification" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'trafficClassification')}, checked: dimensionGroupSwitch "/>
                                            </label>
                                        </li>                                          
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Device Model">
                                                <span>Device Model</span>
                                                <input type="radio" id="radio-dimension-deviceModel" name="switch-dimension-deviceModel" value="deviceModel" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'deviceModel')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Operating System">
                                                <span>Operating System</span>
                                                <input type="radio" id="radio-dimension-os" name="switch-dimension-os" value="os" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'os')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Browser">
                                                <span>Browser</span>
                                                <input type="radio" id="radio-dimension-browser" name="switch-dimension-browser" value="browser" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'browser')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Browser Version">
                                                <span>Browser Version</span>
                                                <input type="radio" id="radio-dimension-browserVersion" name="switch-dimension-browserVersion" value="browserVersion" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'browserVersion')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Ad Block">
                                                <span>Ad Block</span>
                                                <input type="radio" id="radio-dimension-adBlockerStatus" name="switch-dimension-adBlockerStatus" value="adBlockerStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'adBlockerStatus')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="User Agent">
                                                <span>User Agent</span>
                                                <input type="radio" id="radio-dimension-userAgent" name="switch-dimension-userAgent" value="userAgent" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'userAgent')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Geo">
                                                <span>Geo</span>
                                                <input type="radio" id="radio-dimension-geo" name="switch-dimension-geo" value="geo" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'geo')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Region">
                                                <span>Region</span>
                                                <input type="radio" id="radio-dimension-region" name="switch-dimension-region" value="region" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'region')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="City">
                                                <span>City</span>
                                                <input type="radio" id="radio-dimension-city" name="switch-dimension-city" value="city" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'city')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Page Path">
                                                <span>Page Path</span>
                                                <input type="radio" id="radio-dimension-permalink" name="switch-dimension-permalink" value="permalink" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'permalink')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="AMP">
                                                <span>AMP</span>
                                                <input type="radio" id="radio-dimension-ampStatus" name="switch-dimension-ampStatus" value="ampStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'ampStatus')}, checked: dimensionGroupSwitch "/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Referrer">
                                                <span>Referrer</span>
                                                <input type="radio" id="radio-dimension-referrer" name="switch-dimension-referrer" value="referrer" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'referrer')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>                                      
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Traffic Channel">
                                                <span>Traffic Channel</span>
                                                <input type="radio" id="radio-dimension-trafficChannel" name="switch-dimension-trafficChannel" value="trafficChannel" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'trafficChannel')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Hostname">
                                                <span>Hostname</span>
                                                <input type="radio" id="radio-dimension-hostname" name="switch-dimension-hostname" value="hostname" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'hostname')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="IP">
                                                <span>IP</span>
                                                <input type="radio" id="radio-dimension-ip" name="switch-dimension-ip" value="ip" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'ip')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Login Status">
                                                <span>Login Status</span>
                                                <input type="radio" id="radio-dimension-loginStatus" name="switch-dimension-loginStatus" value="loginStatus" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'loginStatus')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Plan">
                                                <span>Plan</span>
                                                <input type="radio" id="radio-dimension-plan" name="switch-dimension-plan" value="plan" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'plan')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Identity Source">
                                                <span>Identity Source</span>
                                                <input type="radio" id="radio-dimension-identity-source" name="switch-dimension-identity-source" value="identitySource" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'identitySource')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Robot Name">
                                                <span>Robot Name</span>
                                                <input type="radio" id="radio-dimension-robotName" name="switch-dimension-robotName" value="robotName" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'robotName')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="Robot Category">
                                                <span>Robot Category</span>
                                                <input type="radio" id="radio-dimension-robotCategory" name="switch-dimension-robotCategory" value="robotCategory" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'robotCategory')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span class="label-default icon i-dimensions">UTMs</span>
                                    <ul class="sidebar-default-list">
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Campaign">
                                                <span>UTM Campaign</span>
                                                <input type="radio" id="radio-dimension-utmCampaign" name="switch-dimension-utmCampaign" value="utmCampaign" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmCampaign')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Medium">
                                                <span>UTM Medium</span>
                                                <input type="radio" id="radio-dimension-utmMedium" name="switch-dimension-utmMedium" value="utmMedium" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmMedium')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="label-checkbox-menu-default" title="UTM Source">
                                                <span>UTM Source</span>
                                                <input type="radio" id="radio-dimension-utmSource" name="switch-dimension-utmSource" value="utmSource" data-bind="event: {change: onDimensionGroupSwitch.bind($data, 'utmSource')}, checked: dimensionGroupSwitch"/>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <!-- ko if: customDimensionsNames().length > 0 -->
                                    <div>
                                        <span class="label-default icon i-dimensions">Custom Dimensions</span>
                                        <ul class="sidebar-default-list">
                                            <!-- ko foreach: customDimensionsNames -->
                                                <li>
                                                    <label class="label-checkbox-menu-default" title="Default" data-bind="attr: {title: name}">
                                                        <span data-bind="text: name"></span>
                                                        <input type="radio" data-bind="attr: { id: 'radio-dimension-' + name, name: 'switch-dimension-' + name, value: name }, event: { change: $parent.onDimensionGroupSwitch.bind($parent, name) }, checked: $parent.dimensionGroupSwitch"/>                            </label>
                                                </li>
                                            <!-- /ko -->
                                        </ul>
                                    </div>
                                <!-- /ko -->
                            </div>

                        </nav>
                    </div>

                    <nav class="sidebar-default sidebar-default-right" data-bind="css:{'is-open': isFiltersOpen()}">
                        <div class="sidebar-default-header">
                            <span class="label-default sidebar-default-header icon i-filters">Filters</span>
                            <button type="button" class="btn-close-default icon i-close" data-bind="event: { click: toggleOpenFilters }"><span></span></button>
                        </div>

                        <div class="sidebar-default-body">

                            <div>

                                <!-- ko foreach: dynamicFiltersGrouped -->

                                    <span class="form-label" data-bind="text: categoryName"></span>

                                    <div class="dynamic-filters w-add-filters-list">
                                    <!-- ko foreach: Object.values(names) -->

                                        <div class="filter-group">

                                            <div class="checkbox-group">
                                                <label class="icon i-dropdown-simple">
                                                    <input class="expected" type="checkbox" />
                                                </label>
                                            </div>

                                            <!-- ko foreach: filters -->

                                                <!-- ko if: type === 'multiSelect' -->
                                                    <div data-bind="template: {name: 'multiSelector-template', data: filter.getTemplateViewModel()}" class="has-multi"></div>
                                                <!-- /ko -->

                                                <!-- ko if: type === 'autoCompleteMultiSelect' -->
                                                    <div data-bind="template: {name: 'filterMultipleAutoComplete-template', data: filter.getTemplateViewModel()}"></div>
                                                <!-- /ko -->

                                                <!-- ko if: type === 'searchField' -->
                                                    <div data-bind="template: {name: 'filterSimple-template', data: filter.getTemplateViewModel()}"></div>
                                                <!-- /ko -->

                                            ${dynamicFilterOperators.html}

                                            <!-- /ko -->
                                        </div> <!-- End filter-group -->
                                    <!-- /ko -->
                                    </div>
                                <!-- /ko -->

                            </div>
                        </div>
                    </nav>

                    <div class="w-right flex-all block-default">
                        <div class="w-justify full-width">
                            <div class="w-left">
                                <div class="w-brand-filter">
                                    ${this.brandFilter.getHtmlBuild()}
                                </div>

                                <div>
                                    ${this.dateRangeFilter.getHtmlBuild()}
                                </div>

                                <div class="separator"></div>

                                <button class="icon i-filters no-after filterToggle-btn" data-bind="event: {click: toggleOpenFilters}">Filters</button>

                            </div>

                            <div class="w-right">
                                <div class="w-filter-preset hide-mobile" data-bind="visible: false, event: { mouseover: onMouseOverPreset, mouseout: onMouseOutPreset}">
                                    ` + this.presetFilter.getHtmlBuild() + `
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="w-justify">
                    <div class="w-left">
                        <div class="w-filters-selected">
                            <div class="filters-selected">
                                <div id="selected-geos"></div>
                                <div id="selected-devices"></div>
                                <div id="selected-os"></div>
                                <div id="selected-browsers"></div>
                                <div id="selected-login-status"></div>
                                <div id="selected-referrers"></div>
                                <div id="selected-plans"></div>
                                <div id="selected-ad-blocks"></div>
                                <!-- ko foreach: dynamicFilters -->
                                    <div data-bind="attr: { id: 'selected-' + name }, css: {'filter-excluded': filter.getTemplateViewModel().filterOperator() === 'exclude'}"></div>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ko if: sampledDatesData() && sampledDatesData().length > 0 -->
                    <div class="w-block-message plus theme-light">
                        <div class="block-message-content">
                            <p><strong>Note:</strong> The selected date range includes periods where data was sampled.</p>
                        </div>
                    </div>
                <!-- /ko -->

                <section class="w-graph block-default rogue no-padding">
                    <div class="w-justify" style="width: 100%;margin-top: 1rem">
                        <div style="margin-right: 1rem" class="w-right" data-bind= "visible: timelineAnnotationsData().length">
                            <span class="label-annotation"></span>
                            <div class="w-tooltips-adv auto-height short pos-top-left">
                                ${this.annotationTooltip.getHtmlBuild()}
                            </div>
                        </div>
                    </div>

                    <div class="graph" id="indicatorsByDate-results"  data-bind="css: { loading: false }">
                        ${this.eventsChart.getHtmlBuild()}
                    </div>
                </section>



                <div id="dimensionsByDate-results" class="wrapper-list-results">

                    <div class="w-justify list-results-header">
                        <div class="w-left">
                            ` + this.pagination.getHtmlBuild() + `
                        </div>
                        <div class="w-center">
                            ` + this.resultsInfo.getHtmlBuild() + `
                        </div>
                        <div class="w-right">
                            <button class="button-default icon i-export" type="button" data-bind="event: {click: exportData}">Export</button>
                        </div>
                    </div>

                    <div class="gradient-overflow">
                        <div class="w-list-results">
                            <table class="list-results interaction-overview" style="white-space: nowrap;">
                                <thead>
                                    <tr>

                                        <th><span data-bind="text: dimensionGroupSwitch() === 'time' ? '' : 'Top Dimensions'"></span></th>

                                        <th>
                                            <span>Category</span>
                                        </th>

                                        <th>
                                            <span>Name</span>
                                        </th>

                                        <th>
                                            <span>Value</span>
                                        </th>

                                        <th>
                                            <span>Event count</span>
                                        </th>
                                    </tr>

                                </thead>

                                <tbody>

                                    <!-- ko if: dimensionsTotals.length > 0 -->
                                        <tr class="total-row">
                                            <td>
                                                <span data-bind="text: 'Total'"></span>
                                            </td>

                                            <!-- ko with: dimensionsTotals -->
                                                    <td>
                                                        <span></span>
                                                    </td>
                                                    <td>
                                                        <span></span>
                                                    </td>
                                                    <td>
                                                        <span></span>
                                                    </td>
                                                    <td>
                                                        <span data-bind="text: Number($data.eventCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                                    </td>
                                            <!-- /ko -->
                                        </tr>
                                    <!-- /ko -->

                                    <!-- ko foreach: dimensionsData -->
                                        <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data)}, style: { 'background-color': $parent.selectedRows().indexOf($index()) !== -1 ? '#dbdbed' : '' }">
                                            
                                            <!-- ko if: $parent.dimensionGroupSwitch() === 'time' -->
                                                <td>
                                                    <span class="align-left no-wrap" data-bind="text: date"></span>
                                                </td>
                                            <!-- /ko -->

                                            <!-- ko ifnot: $parent.dimensionGroupSwitch() === 'time' -->
                                                <td>
                                                    <span data-bind="text: dimension"></span>
                                                </td>
                                            <!-- /ko -->

                                            <td>
                                                <span data-bind="text: category"></span>
                                            </td>

                                            <td>
                                                <span data-bind="text: name"></span>
                                            </td>

                                            <td>
                                                <span data-bind="text: value"></span>
                                            </td>

                                            <td>
                                                <span data-bind="text: isNaN($data.eventCount) || $data.eventCount === null ? $data.eventCount : Number($data.eventCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                            </td>
                                        </tr>
                                    <!-- /ko -->

                                </tbody>

                            </table>
                        </div>

                    </div>

                </div>
            </div>
            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>
        `;
    }

    /**
     * @inheritDoc
     */
    protected initPartial(): void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('interactionOverview');

        this.pagination = new pagination_template('pagination', this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;

        this.brandFilter = new filterSingle_multiLevel_selector_template('brandFilter', this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel('Property');
        this.brandFilter.setAllOptionsText('Network');
        this.brandFilter.setHasLogo(true);
        this.brandFilter.setDefaultLogo(vnApp_sentinelbi.BRAND_DEFAULT_ICON_PATH);

        this.exportDataCsv = new exportDataCsv();

        this.resultsInfo  = new resultsInfo_template('resultsInfo', this.getTemplateViewModel(), this.caller);


        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){
            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{
            date.setDate(date.getDate() - 1);
        }


        this.dateRangeFilter = new filterDate_template("dateRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dateRangeFilter.setStartPickerId('dateRangeStartDatePicker');
        this.dateRangeFilter.setEndPickerId('dateRangeEndDatePicker');
        this.dateRangeFilter.setDateRange(firstOfMonth, date);

        this.eventsChart = new amCharts_v4_date_basic_template('eventsChart', this.getTemplateViewModel(), this.caller);

        window.addEventListener('click', event => {

            const sidebarFilters = document.querySelector('.sidebar-filters-js-only');
            const addFiltersDropdown = document.querySelector('.sidebar-default-right');
            const addFiltersButton = document.querySelector('.filterToggle-btn');

            if(!sidebarFilters?.contains(event.target as Element)){
                this.getTemplateViewModel().sidebarToggle(false);
            }

            if(!addFiltersDropdown?.contains(event.target as Element) && !addFiltersButton?.contains(event.target as Element) && !(event.target as Element).closest('.form-auto-item') && !(event.target as Element).closest('.btn-f-s')){
                this.getTemplateViewModel().isFiltersOpen(false);
            }
        })

        this.annotationTooltip = new infoButton_template('annotationTooltip', this.getTemplateViewModel(), this.caller)
        this.annotationTooltip.setContent('');
    }

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string{

        return 'interactionOverview_template';
    }

    /**
     * @inheritDoc
     */
    public buildViewModel(): Object {

        let self = this;

        return {
            reportStatusData: ko.observable(),
            sampledDatesData: ko.observableArray([]),
            dynamicFiltersData: ko.observableArray([]),
            dynamicFilters: ko.observableArray([]),
            dynamicFiltersGroupedByName: ko.observableArray([]),
            dynamicFiltersGrouped: ko.observableArray([]),
            customDimensionsNames: ko.observableArray([]),
            graphAxes: ko.observableArray([]),
            graphLinesInfo: ko.observableArray([]),
            indicatorsDateRange: ko.observableArray([]),
            timelineAnnotationsData: ko.observableArray([]),
            dimensionsData: ko.observableArray([]),
            dimensionsExportData: ko.observableArray([]),
            dimensionsExportTotals: ko.observable(),
            dimensionsTotals: ko.observable(),
            timeGroupSwitch: ko.observable('daily'),
            dimensionGroupSwitch: ko.observable('time'),
            brandHeaders: ko.observableArray([]),
            brandsDataPerDimension: ko.observableArray([]),
            brandsTotalsPerDimension: ko.observable(),
            viewMode: ko.observable('traffic'),
            showAdvancedFilters: ko.observable(false),
            indicatorDataLoaded: ko.observable(false),
            isPresetVisible: ko.observable(true),
            selectedRows: ko.observableArray([]),
            sidebarToggle: ko.observable(false),
            isFiltersOpen: ko.observable(false),
            exportData: function(){ self.getCsvData(); },
            toggleOpenFilters: function(data){

                self.toggleOpenFilters();
            },
            onTimeGroupSwitch: function(data, event){

                self.onTimeGroupSwitch(data, event);
            },
            onDimensionGroupSwitch: function(data, event){

                self.onDimensionGroupSwitch(data, event);
            },
            onExportData: function(){

                self.getCsvData();
            },
            onShowAdvancedFilters: function(){

                self.onShowAdvancedFilters();
            },
            onMouseOverPreset : function () {
                self.onMouseOverPreset();
            },
            onMouseOutPreset : function () {
                self.onMouseOutPreset();
            },
            onClickRowClick: function(index, data){
                self.onClickRowClick(index);
            },
            formatMinuteSeconds: function(value){
                return self.formatMinuteSeconds(value);
            },
            onSidebarToggle: function(){
                self.onSidebarToggle();
            }
        }
    }

    public setCsvExportData(exportData){

        this.getTemplateViewModel().dimensionsExportData(exportData.tableData);
        this.getTemplateViewModel().dimensionsExportTotals(exportData.totals);
    }

    private getCsvData(){

        this.caller.getListDataForCSV();
    }

    private toggleOpenFilters(){

        this.getTemplateViewModel().isFiltersOpen(!this.getTemplateViewModel().isFiltersOpen());
    }

    private onSidebarToggle(){

        this.getTemplateViewModel().sidebarToggle(!this.getTemplateViewModel().sidebarToggle());
    }

    private formatMinuteSeconds(value){

        if (isNaN(parseInt(value))) {

            return value;
        } else {

            return Math.floor(parseInt(value) / 60) + ":" + (parseInt(value) % 60).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            });
        }
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);
        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public setDynamicFilters(dynamicFiltersData: Array<any>){

        let i = 0;
        let dynamicFilters = [];

        for (let category in dynamicFiltersData) {

            if (dynamicFiltersData.hasOwnProperty(category)) {

                let filtersData = dynamicFiltersData[category];

                filtersData.forEach((filterData) => {

                    let filter, filterId;

                    // multi select
                    if(filterData.type === 'multiSelect'){

                        filterId = filterData.id;
                        filter = new multipleSelector_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setLabel(filterData.name);
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setItems(filterData.values);
                        filter.setShowCount(true);
                        filter.setShowClear(true);

                        if(filterData.hasSearchFilter){

                            filter.setContainSearchEnabled(true);
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                    // multi select autocomplete
                    else if(filterData.type === 'autoCompleteMultiSelect'){

                        filterId = filterData.id;
                        filter = new filterMultipleAutoComplete_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setIsVisible(1);
                        //filter.setPlaceHolderText(filterData.name);
                        filter.setIcon("i-tag-a");
                        filter.setTagContainerId('selected-' + filterData.name);
                        filter.setTagContainerCaption('Selected ' + filterData.name + ':');
                        filter.setMinInputSuggestionLength(2);
                        filter.setLabel(filterData.name);
                        filter.setShowCount(true);
                        filter.setShowClear(true);

                        if(filterData.hasSearchFilter){

                            filter.setContainSearchEnabled(true);
                        }

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                    else if(filterData.type === 'searchField'){

                        filterId = filterData.id;
                        filter = new filterSimple_template(filterId, this.getTemplateViewModel(), this.caller);
                        filter.setLabel(filterData.name);

                        dynamicFilters.push({
                            filter: filter,
                            filterId: filterId,
                            name: filterData.name,
                            type: filterData.type,
                            category: filterData.category,
                            categoryName: filterData.categoryName
                        });
                    }
                })
            }
        }

        dynamicFilterOperators.initialize(dynamicFilters, this.caller);
        this.getTemplateViewModel().dynamicFilters(dynamicFilters);

        let dynamicFiltersGrouped = Object.values(dynamicFilters.reduce((acc, item) => {

            // Check if the category already exists
            if (!acc[item.categoryName]) {
                acc[item.categoryName] = {
                    categoryName: item.categoryName,
                    names: {}
                };
            }

            // Check if the name already exists within the category
            if (!acc[item.categoryName].names[item.name]) {
                acc[item.categoryName].names[item.name] = {
                    name: item.name,
                    filters: []
                };
            }

            // Push the filter into the correct name group
            acc[item.categoryName].names[item.name].filters.push({
                type: item.type,
                filter: item.filter,
                filterId: item.filterId
            });

            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGrouped(dynamicFiltersGrouped);

        let dynamicFiltersGroupedByName = Object.values(dynamicFilters.reduce((acc, item) => {

            if (!acc[item.name]) {
                acc[item.name] = { name: item.name, category: item.category, filters: [] };
            }
            acc[item.name].filters.push({ type: item.type, filter: item.filter, filterId: item.filterId });
            return acc;
        }, {}));

        this.getTemplateViewModel().dynamicFiltersGroupedByName(dynamicFiltersGroupedByName);

        // Custom dimension names
        let customDimensionsNames = dynamicFilters.reduce((acc, item) => {
            if (item.category === "Custom Dimensions" && !acc.find(obj => obj.name === item.name)) {
                acc.push({ name: item.filterId.split('-')[0] });
            }
            return acc;
        }, []);

        this.getTemplateViewModel().customDimensionsNames(customDimensionsNames);
    }

    public setDynamicAutoCompleteMultiSelectFilterItems(filterId, items){

        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        let filter = dynamicFilters.find(filters => filters.filter.idElement === filterId).filter;
        if (filter) {

            filter.setItems(items);
            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }
        filter.setItems(items);
    }

    public setTimelineAnnotationsData(timelineAnnotationsData) {

        for(let i = 0; i < timelineAnnotationsData.length; i++) {

            timelineAnnotationsData[i].dateOrig = timelineAnnotationsData[i].date;
            timelineAnnotationsData[i].date = new Date(timelineAnnotationsData[i].date);
        }

        this.getTemplateViewModel().timelineAnnotationsData(timelineAnnotationsData);

        // format for tooltip
        let formattedAnnotationTooltip = '<ul>';
        for(let i = 0; i < timelineAnnotationsData.length; i++) {

            let formattedDate = timelineAnnotationsData[i].dateOrig.substring(0, 10)
            if (this.getTemplateViewModel().timeGroupSwitch() == "hourly") {

                formattedDate = timelineAnnotationsData[i].dateOrig.substring(0, 13)+'H'
            }
            formattedAnnotationTooltip += '<li class="col"><strong>' + formattedDate + '</strong><p>'+ timelineAnnotationsData[i].annotation +'</p></li>';
        }
        formattedAnnotationTooltip += '</ul>';


        this.annotationTooltip.setContent(formattedAnnotationTooltip);
    }

    public clearTimelineAnnotatonData(){

        this.getTemplateViewModel().timelineAnnotationsData([]);
    }

    /**
     * @inheritDoc
     */
    public getViewModelForRequest(): Object{

        let selectedDynamicFilters = [];
        let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
        if(typeof dynamicFilters !== "undefined" && dynamicFilters !== null && Object.keys(dynamicFilters).length !== 0) {

            for(let dynamicFilter of dynamicFilters) {

                if(dynamicFilter.type === 'multiSelect') {

                    let items = dynamicFilter.filter.getTemplateViewModel().items();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let filteredItems = items.filter(item => selectedIds.includes(item.id));

                    if(filteredItems.length > 0 || searchKeyword) {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
                else if(dynamicFilter.type === 'autoCompleteMultiSelect') {

                    let selectedIds = dynamicFilter.filter.getTemplateViewModel().selectedItems();
                    let searchKeyword = dynamicFilter.filter.getContainSearchFilterKeyword();
                    let filteredItems = selectedIds;

                    if(filteredItems.length > 0 || searchKeyword) {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {

                                [dynamicFilter.name]: {

                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    items: filteredItems,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
                else if(dynamicFilter.type === 'searchField') {

                    let searchKeyword = dynamicFilter.filter.getTemplateViewModel().filterKeyword();

                    if(searchKeyword) {

                        selectedDynamicFilters.push({

                            [dynamicFilter.category]: {
                                [dynamicFilter.name]: {
                                    id: dynamicFilter.filterId,
                                    type: dynamicFilter.type,
                                    keyword: searchKeyword
                                }
                            }
                        });
                    }
                }
            }
        }

        return {
            filters : {
                selectedDynamicFilters: dynamicFilterOperators.forRequest(selectedDynamicFilters, dynamicFilters),
                selectedBrand: this.brandFilter.getTemplateViewModel().selectedOption(),
                selectedBrandText: this.brandFilter.getTemplateViewModel().selectedOptionText(),
                dateFilterType: this.getTemplateViewModel().dateRangeFilter.selectedFilter(),
                selectedMonth: this.getTemplateViewModel().dateRangeFilter.selectedMonth(),
                selectedWeek: this.getTemplateViewModel().dateRangeFilter.selectedWeek(),
                startDate: this.getTemplateViewModel().dateRangeFilter.startDate(),
                endDate: this.getTemplateViewModel().dateRangeFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateRangeFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateRangeFilter.toRange(),
                timeGroupSwitch: this.getTemplateViewModel().timeGroupSwitch(),
                dimensionGroupSwitch: this.getTemplateViewModel().dimensionGroupSwitch(),
                pagination: this.getTemplateViewModel().pagination
            }
        };
    }

    public updateViewMode(): void{

        this.getTemplateViewModel().viewMode(this.getTemplateViewModel().tableMetricFilter.selectedOption());
    }

    /**
     * Build the date Picker calendar.
     */
    public buildDatePickerCalendar() {

        this.dateRangeFilter.buildCalendar();
    }

    public setDefaultDevices(){

        // Select by default Mobile, Desktop, Tablet
        const filter = this.getTemplateViewModel().dynamicFilters().find(f => f.filterId == 'device-internalDimension').filter;

        let defaultDevices = ['Mobile', 'Desktop', 'Tablet'];
        let filterItems = filter.getItems().filter(i => i && defaultDevices.includes(i.name));
        let filterItemIds = filterItems.map(i => i.id);

        if(filter.getTemplateName() === 'multiSelector-template'){

            filter.setSelectedItems(filterItems);
            filter.setTags(filterItemIds, filter.getItems());
        }

        dynamicFilterOperators.setDefaultHttpStatus(this.getTemplateViewModel().dynamicFilters());
    }

    public updatePagination(totalCount){

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    public setIndicatorDataLoaded(value){

        this.getTemplateViewModel().indicatorDataLoaded(value);
    }

    public setReportStatusData(reportStatusData) {

        this.getTemplateViewModel().reportStatusData(reportStatusData);
    }

    public setSampledDatesData(sampledDatesData) {

        this.getTemplateViewModel().sampledDatesData(sampledDatesData);
    }

    public setIndicatorsData(indicatorsData) {

        this.getTemplateViewModel().graphAxes(indicatorsData.graphAxes);
        this.getTemplateViewModel().graphLinesInfo(indicatorsData.graphLinesInfo);

        if (indicatorsData.dateRange.data) {
            // convert date strings to date objects for am4charts.
            for(let i = 0; i < indicatorsData.dateRange.data.length; i++) {

                indicatorsData.dateRange.data[i].date = new Date(indicatorsData.dateRange.data[i].date);
            }
        }

        this.getTemplateViewModel().indicatorsDateRange(indicatorsData.dateRange);
    }

    public clearIndicatorData(){

        this.getTemplateViewModel().graphAxes(null);
        this.getTemplateViewModel().graphLinesInfo(null);
        this.getTemplateViewModel().indicatorsDateRange(null);
    }

    public setBrandFilterItems(portfolios): void{

        let groups = [];

        this.brandFilter.setIncludeAllOptions(true);

        for(let portfolio of portfolios){

            let subGroups = [];

            let portfolioItem = {"id": portfolio.id, "name": portfolio.name, "cssClasses": portfolio.logo, "type": 'portfolio'};

            if (!(typeof(portfolio.disabled) !== 'undefined' && portfolio.disabled === true)){

                groups.push(portfolioItem);

                for(let brand of portfolio.brands){

                    let brandItem = {"id": brand.id, "name": brand.name, "cssClasses": brand.logo, "iconUrl": brand.logoUrl, "type": 'brand'};

                    subGroups.push(brandItem);
                }
                portfolioItem['subGroups'] = subGroups;
            }else{

                for(let brand of portfolio.brands){

                    let brandItem = {"id": brand.id, "name": brand.name, "cssClasses": brand.logo, "iconUrl": brand.logoUrl, "type": 'brand'};
                    groups.push(brandItem);

                }
            }

        }

        // call setGroups function

        this.brandFilter.setGroups(groups);
        //this.brandFilter.setSelectedOption('all');
    }

    public onTimeGroupSwitch(data, event){

        this.getTemplateViewModel().timeGroupSwitch(data);
        this.caller.getReportData();
    }

    public onDimensionGroupSwitch(data, event){

        this.getTemplateViewModel().dimensionGroupSwitch(data);
        this.caller.getReportData();
    }

    public onShowAdvancedFilters(){

        this.getTemplateViewModel().showAdvancedFilters(!this.getTemplateViewModel().showAdvancedFilters());
    }

    protected onMouseOverPreset(){

        this.getTemplateViewModel().isPresetVisible(true);
    }

    protected onMouseOutPreset(){

        this.getTemplateViewModel().isPresetVisible(false);
    }

    public exportCsvData() {

        let exportDataView = [];

        exportDataView = this.generateCSVForEvents();

        this.exportDataCsv.exportToCsv("interaction_overview_export", exportDataView);
    }

    private generateCSVForEvents(){

        let exportDataView = [];

        for (let exportDataRow of this.getTemplateViewModel().dimensionsExportData()) {

            let exportDataViewRow = [];

            if(this.getTemplateViewModel().dimensionGroupSwitch() === "time"){

                exportDataViewRow["Dimension"] = exportDataRow.date;
            }
            else{

                exportDataViewRow["Dimension"] = exportDataRow.dimension;
            }
            exportDataViewRow["Category"] = exportDataRow.category;
            exportDataViewRow["Name"] = exportDataRow.name;
            exportDataViewRow["Value"] = exportDataRow.value;
            exportDataViewRow["Events"] = Number(exportDataRow.eventCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});

            exportDataView.push(exportDataViewRow);
        }


        let exportDataRow = this.getTemplateViewModel().dimensionsExportTotals();
        let exportDataTotalViewRow = [];

        exportDataTotalViewRow["Dimension"] = 'Total';
        exportDataTotalViewRow["Events"] = Number(exportDataRow.eventCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});

        exportDataView.push(exportDataTotalViewRow);


        return exportDataView;

    }

    public setResultPage(nbResults, nbPages, execTime) {
        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }


    public updateIndicatorsGraphData(){

        this.eventsChart.setCssHeight("230px");

        let axes = this.getTemplateViewModel().graphAxes();
        let graphLines = this.getTemplateViewModel().graphLinesInfo();
        let chartData = this.getTemplateViewModel().indicatorsDateRange().data;

        this.eventsChart.setNbOfXAxes(axes.length)
        this.eventsChart.setDateFormat(this.getTemplateViewModel().timeGroupSwitch());
        this.eventsChart.setDateFields(axes);
        this.eventsChart.setCursorEnabled(1);
        this.eventsChart.setLabelMaxWidth(80);
        this.eventsChart.setAutoRotateLabels(1);
        this.eventsChart.setClickableLegend(1);
        this.eventsChart.setXScrollbarEnabled(0);

        let chart = this.eventsChart.setupChart(chartData);

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        this.eventsChart.applyValueAxisFormatting(valueAxis);
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;

        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;

        let count = 0;
        if(graphLines){

            for (let graphLine of graphLines) {

                let series = chart.series.push(new am4charts.LineSeries());

                if(axes.length>1){

                    series.xAxis = this.eventsChart.getDateAxes()[count];
                }

                let color = interactionOverview_template.getPaletteColor(count);
                if(axes.length>count){

                    series.xAxis.renderer.labels.template.fill = am4core.color(color);
                }

                series.dataItems.template.locations.categoryX = 0.5;
                series.dataFields.valueY =  graphLine.value;
                series.dataFields.customValue = graphLine.value;
                series.dataFields.dateX = graphLine.field;
                series.strokeOpacity = 1;
                series.strokeWidth = 2;
                series.fill = am4core.color(color);
                series.stroke = am4core.color(color);
                series.yAxis = valueAxis;
                series.name = graphLine.name;

                series.tooltipText = "{name}: [bold]{customValue}[/]";

                series.smoothing = "monotoneX";
                series.showOnInit = true;

                let interfaceColors = new am4core.InterfaceColorSet();

                let bullet = series.bullets.push(new am4charts.CircleBullet());
                bullet.circle.radius = 4;
                bullet.circle.opacity = 1;
                bullet.circle.strokeWidth = 1;
                bullet.circle.stroke = interfaceColors.getFor("background");
                bullet.circle.opacity = 1;
                bullet.circle.strokeOpacity = 0.9;

                series.minBulletDistance = 2.5;

                count++;
            }
        }

        chart.events.once("ready", () => {

            for (let annotation of this.getTemplateViewModel().timelineAnnotationsData()) {

                // Use the axis of a known series to choose the correct x-axis (you have multiple).
                const series0 = chart.series.getIndex(0) as am4charts.LineSeries;
                if (!series0 || !series0.xAxis) return;

                // Cast the axis to DateAxis so TS knows about min/max, strictMinMax, etc.
                const xAxis = series0.xAxis as am4charts.DateAxis;

                // The moment you want to mark:
                let eventDateTmp = annotation.date;


                let lineOffset = 43200000;
                if (this.getTemplateViewModel().timeGroupSwitch() == "hourly") {

                    lineOffset = 1800000;
                }else {

                    eventDateTmp.setHours(0, 0, 0, 0);
                }

                let offset = (eventDateTmp.getTimezoneOffset() * 60 * 1000);


                let eventDate = new Date(eventDateTmp.getTime() - offset + lineOffset);


                const ts = +eventDate;

                // Create the range and cast it to DateAxisDataItem so .value/.date are valid
                const range = xAxis.axisRanges.create() as am4charts.DateAxisDataItem;

                // Either set value (timestamp) or date (Date) — both are valid on DateAxisDataItem
                range.value = ts;              // or: range.date = eventDate;

                // Style the line
                range.grid.stroke = am4core.color("#FF0000");
                range.grid.strokeWidth = 2;
                range.grid.strokeOpacity = 1;
                range.grid.strokeDasharray = "4,4";
                range.grid.zIndex = 1000;

                // Label / note
                //range.label.text = "Annotation";
                range.label.rotation = -90;
                range.label.horizontalCenter = "right";
                range.label.verticalCenter = "bottom";
                range.label.dy = -150;                     // tweak up/down if needed

                range.label.inside = true;
                range.label.fill = am4core.color("#D41C5C");
                range.label.padding(0, 6, 0, 6);
            }
        });

        if(chart.logo){

            chart.logo.disabled = true;
        }
    }

    public setDimensionsData(dimensionsData, dimensionsTotals) {

        this.getTemplateViewModel().selectedRows([]);

        let dimensionGroupSwitch = this.getTemplateViewModel().dimensionGroupSwitch();
        let timeGroupSwitch = this.getTemplateViewModel().timeGroupSwitch();

        if (dimensionGroupSwitch == 'time') {

            for (let item of dimensionsData) {

                item.dimension = this.formatDate(item.dimension, (timeGroupSwitch == 'hourly'));
            }

        }

        this.getTemplateViewModel().dimensionsTotals(dimensionsTotals);
        this.getTemplateViewModel().dimensionsData(dimensionsData);
    }

    public setBrandsData(brandHeaders, tableData, totals) {

        this.getTemplateViewModel().selectedRows([]);

        let dimensionGroupSwitch = this.getTemplateViewModel().dimensionGroupSwitch();
        let timeGroupSwitch = this.getTemplateViewModel().timeGroupSwitch();

        if (dimensionGroupSwitch == 'time') {

            for (let item of tableData) {

                item.dimension = this.formatDate(item.dimension, (timeGroupSwitch == 'hourly'));
            }
        }

        this.getTemplateViewModel().brandHeaders(brandHeaders);
        this.getTemplateViewModel().brandsDataPerDimension(tableData);
        this.getTemplateViewModel().brandsTotalsPerDimension(totals);
    }

    static getPaletteColor(number) {
        switch(number) {
            case 0:
                return "#312D69";
            case 1:
                return "#D8366D";
            case 2:
                return "#1CA71C"; // Bold Green
            case 3:
                return "#FB0D0D"; // Vivid Red
            case 4:
                return "#DA16FF"; // Purple
            case 5:
                return "#222A2A"; // Dark Gray
            case 6:
                return "#FFC800"; // Bright Yellow
            case 7:
                return "#00C49A"; // Teal
            case 8:
                return "#FF5733"; // Orange-Red
            case 9:
                return "#6A329F"; // Deep Purple
            default:
                return "#000000";  // Default case if number doesn't match any case
        }
    }

    static stringToColour(str){

        let hash = 0;
        for (let i = 0; i < str.length; i++){

            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++){

            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }

        return colour;
    }

    private formatDate(date, hours) {

        let weekday = new Array(7);
        weekday[0] = "Sun";
        weekday[1] = "Mon";
        weekday[2] = "Tue";
        weekday[3] = "Wed";
        weekday[4] = "Thu";
        weekday[5] = "Fri";
        weekday[6] = "Sat";

        if (!hours) {

            date = date + " 00:00:00";
        }

        let d = new Date(date);

        let month = '0' + (d.getMonth()+ 1);
        month = month.slice(-2);

        let day = '0' + d.getDate();
        day = day.slice(-2);

        let year = d.getFullYear();
        let dayOfWeek = weekday[d.getDay()];

        let currentHours = '0' + d.getHours();
        currentHours = currentHours.slice(-2);

        return dayOfWeek + ', ' + [year, month, day].join('-') + ((hours) ? ' ' + currentHours + 'h' : '');
    }

    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params['selectedBrand'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOption(params['selectedBrand']);
        }

        if(typeof params['selectedBrandText'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOptionText(params['selectedBrandText']);
        }

        if(typeof params['timeGroupSwitch'] !== 'undefined'){

            this.getTemplateViewModel().timeGroupSwitch(params['timeGroupSwitch']);
        }

        if(typeof params['dimensionGroupSwitch'] !== 'undefined'){

            this.getTemplateViewModel().dimensionGroupSwitch(params['dimensionGroupSwitch']);
        }

        if(typeof params['selectedDynamicFilters'] !== 'undefined' && Array.isArray(params['selectedDynamicFilters'])){

            let dynamicFilters = this.getTemplateViewModel().dynamicFilters();
            dynamicFilterOperators.restore(dynamicFilters, params['selectedDynamicFilters']);

            params['selectedDynamicFilters'].forEach(selectedDynamicFilter => {

                Object.values(selectedDynamicFilter).forEach(category => {

                    if (typeof category === 'object' && category !== null) {

                        Object.values(category).forEach(categoryFilter => {

                            let dynamicFilter = dynamicFilters.find(obj => obj.filter.idElement === categoryFilter.id);

                            if (dynamicFilter) {

                                let filter = dynamicFilter.filter;

                                if(categoryFilter.type === 'multiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);

                                        this.presetFilter.setMultiSelectorPresetFilters(filter, filterIds, categoryFilter.keyword);
                                    }
                                }
                                else if(categoryFilter.type === 'autoCompleteMultiSelect'){

                                    if(categoryFilter.items.length > 0 || categoryFilter.keyword != ''){

                                        let filterIds = categoryFilter.items.map(obj => obj.id);
                                        let filterNames = categoryFilter.items.map(obj => obj.name);

                                        this.presetFilter.setMultipleAutocompletePresetFilter(filter, filterIds, filterNames, categoryFilter.keyword);
                                    }
                                }
                                else if(categoryFilter.type === 'searchField'){

                                    if(categoryFilter.keyword != ''){

                                        filter.getTemplateViewModel().filterKeyword(categoryFilter.keyword);
                                    }

                                }
                            }
                        });
                    }
                });

            });

            this.getTemplateViewModel().dynamicFilters(dynamicFilters);
        }

        this.presetFilter.setDates(this.dateRangeFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange'], params['selectedMonth'], params['selectedWeek']);
    }

    private isDateDifferenceWithinDays(startDate, endDate, numDays) {

        const dateA = new Date(startDate);
        const dateB = new Date(endDate);

        const diffInMs = Math.abs(dateA.getTime() - dateB.getTime());
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        return (diffInDays + 1) <= numDays;
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/interactionOverview_template.ts